export interface MobileMenu {
  text: string;
  link: string;
}
